import { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import DataTable from "react-data-table-component";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";
import { API_URL } from "../../../utils/constant";
import { customTableStyles } from "../../../utils/tableStylings";
import axios from "axios";
import Swal from "sweetalert2";

const resolveRuleMaterials = (rule, materials) => {
  const resolved = [];
  if (!materials || materials.length === 0) return resolved;

  // 1. Bottle
  if (rule.bottleSize) {
    const sizeStr = rule.bottleSize.toString().toUpperCase().trim();
    const sizeVal = sizeStr.endsWith('ML') ? sizeStr : `${sizeStr}ML`;
    const bottleType = rule.bottleType || 'Regular';

    let mat = materials.find(m => m && m.material_type === 'bottle' && m.bottle_type === bottleType && m.size_val === sizeVal);
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('bottle') && name.includes(sizeStr.toLowerCase()) &&
          (bottleType === 'L' ? name.includes('l bottle') : !name.includes('l bottle'));
      });
    }
    if (mat) resolved.push({ material: mat, qty: 1 });
  }

  // 2. White Cap
  if (parseFloat(rule.whiteCapQty) > 0) {
    const qty = parseFloat(rule.whiteCapQty);
    const num = rule.whiteCapNo ? rule.whiteCapNo.toString().trim() : '';
    const formattedNum = num ? (num.startsWith('No.') ? num : `No. ${num}`) : '';

    let mat = materials.find(m => m && m.material_type === 'white_cap' && (formattedNum ? m.number_val === formattedNum : true));
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('white') && name.includes('cap') && (num ? name.includes(num.toLowerCase()) : true);
      });
    }
    if (mat) resolved.push({ material: mat, qty });
  }

  // 3. Seal Cap
  if (parseFloat(rule.sealCapQty) > 0) {
    const qty = parseFloat(rule.sealCapQty);
    const num = rule.sealCapNo ? rule.sealCapNo.toString().trim() : '';
    const formattedNum = num ? (num.startsWith('No.') ? num : `No. ${num}`) : '';

    let mat = materials.find(m => m && m.material_type === 'seal_cap' && (formattedNum ? m.number_val === formattedNum : true));
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('seal') && name.includes('cap') && (num ? name.includes(num.toLowerCase()) : true);
      });
    }
    if (mat) resolved.push({ material: mat, qty });
  }

  // 4. Dropper
  if (parseFloat(rule.dropperQty) > 0) {
    const qty = parseFloat(rule.dropperQty);
    const size = rule.dropperNo ? rule.dropperNo.toString().toUpperCase().trim() : '';
    const sizeVal = size ? (size.endsWith('ML') ? size : `${size}ML`) : '';

    let mat = materials.find(m => m && m.material_type === 'dropper' && (sizeVal ? m.size_val === sizeVal : true));
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('dropper') && (size ? name.includes(size.toLowerCase()) : true);
      });
    }
    if (mat) resolved.push({ material: mat, qty });
  }

  // 5. Push
  if (parseFloat(rule.pushQty) > 0) {
    const qty = parseFloat(rule.pushQty);
    const num = rule.pushNo ? rule.pushNo.toString().trim() : '';
    const formattedNum = num ? (num.startsWith('No.') ? num : `No. ${num}`) : '';

    let mat = materials.find(m => m && m.material_type === 'push' && (formattedNum ? m.number_val === formattedNum : true));
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('push') && (num ? name.includes(num.toLowerCase()) : true);
      });
    }
    if (mat) resolved.push({ material: mat, qty });
  }

  // 6. Label
  if (rule.labelSize) {
    const size = rule.labelSize.toString().toUpperCase().trim();
    const sizeVal = size.endsWith('ML') ? size : `${size}ML`;

    let mat = materials.find(m => m && m.material_type === 'label' && m.size_val === sizeVal);
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('label') && name.includes(size.toLowerCase());
      });
    }
    if (mat) resolved.push({ material: mat, qty: 1 });
  }

  // 7. Alcohol
  if (parseFloat(rule.alcoholQty) > 0) {
    const qty = parseFloat(rule.alcoholQty);
    let mat = materials.find(m => m && m.material_type === 'alcohol');
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('alcohol') || name.includes('spirit');
      });
    }
    if (mat) resolved.push({ material: mat, qty });
  }

  // 8. Globules
  if (parseFloat(rule.globulesWeight) > 0) {
    const qty = parseFloat(rule.globulesWeight);
    let mat = materials.find(m => m && m.material_type === 'globules');
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('globule') || (name.includes('sugar') && !name.includes('saclac') && !name.includes('lactose'));
      });
    }
    if (mat) resolved.push({ material: mat, qty });
  }

  // 9. Puria
  if (parseFloat(rule.puriaQty) > 0) {
    const qty = parseFloat(rule.puriaQty);
    let mat = materials.find(m => m && m.material_type === 'puria');
    if (!mat) {
      mat = materials.find(m => {
        const name = m && m.name ? m.name.toLowerCase() : '';
        return name.includes('puria') || name.includes('packet') || name.includes('paper');
      });
    }
    if (mat) resolved.push({ material: mat, qty });
  }

  // 10. Water
  if (parseFloat(rule.waterQty) > 0) {
    const qty = parseFloat(rule.waterQty);
    let mat = materials.find(m => m && m.material_type === 'water');
    if (!mat) {
      mat = materials.find(m => m && m.name && m.name.toLowerCase().includes('water'));
    }
    if (mat) resolved.push({ material: mat, qty });
  }

  return resolved;
};

const getDispenseMaterialsCost = (dispenseRule, materials) => {
  const resolved = resolveRuleMaterials(dispenseRule, materials);
  return resolved.reduce((sum, item) => sum + item.qty * (parseFloat(item.material.price) || 0), 0);
};

const PosModel = ({ show, onClose, addCart, heading, initialData = [], cart = [], billType, billingFor }) => {
  console.log('product', initialData);
  const [mode, setMode] = useState("size");
  const [activeTab, setActiveTab] = useState(null);

  const hasLooseStock = Number(initialData?.loose_qty || 0) > 0 || (Array.isArray(initialData?.variations) && initialData.variations.some(v => Number(v.loose_qty || 0) > 0));
  const hasSealedStock = Number(initialData?.quantity || 0) > 0 || (Array.isArray(initialData?.variations) && initialData.variations.some(v => Number(v.qty || 0) > 0 || Number(v.current_wholesale || 0) > 0));
  const isLooseOnly = initialData?.product_value_type === 'Loose' || (hasLooseStock && !hasSealedStock) || billingFor === 'Loose';

  const [stockType, setStockType] = useState(isLooseOnly ? "Loose" : "Sealed"); // "Sealed" or "Loose"

  useEffect(() => {
    if (initialData?.product_value_type === 'Loose' || (hasLooseStock && !hasSealedStock) || billingFor === 'Loose') {
      setStockType("Loose");
    } else {
      setStockType("Sealed");
    }
  }, [initialData, billingFor]);

  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [filteredSalesData, setFilteredSalesData] = useState([]);
  const [dispensingData, setDispensingData] = useState([]);
  const [dispenseMaterials, setDispenseMaterials] = useState([]);
  const [showDispenseModal, setShowDispenseModal] = useState(false);
  const [pendingCartData, setPendingCartData] = useState(null);
  const [transferredQty, setTransferredQty] = useState({});

  // Reset transfer tracking when product changes
  useEffect(() => {
    setTransferredQty({});
  }, [initialData]);

  const handleStockTransfer = async (item, direction, e) => {
    e.stopPropagation();
    const fromLabel = direction === 'wholesale_to_retail' ? 'Wholesale' : 'Retail';
    const toLabel = direction === 'wholesale_to_retail' ? 'Retail' : 'Wholesale';
    const itemId = item.id_variation || item.id;
    const adj = transferredQty[itemId] || { rAdj: 0, wAdj: 0 };
    const effectiveRetail = (parseFloat(item.qty) || 0) + adj.rAdj;
    const effectiveWholesale = (parseFloat(item.current_wholesale) || 0) + adj.wAdj;
    const maxQty = direction === 'wholesale_to_retail' ? effectiveWholesale : effectiveRetail;

    const { value: qty } = await Swal.fire({
      title: `Transfer ${fromLabel} → ${toLabel}`,
      html: `<p><b>${item.variant_name || 'Variation'}</b></p>
             <p>Retail: <b>${effectiveRetail}</b> | Wholesale: <b>${effectiveWholesale}</b></p>
             <p>Max transferable: <b>${maxQty}</b></p>`,
      input: 'number',
      inputLabel: 'Quantity to transfer',
      inputAttributes: { min: 1, max: maxQty, step: 1 },
      inputValidator: (value) => {
        if (!value || parseFloat(value) <= 0) return 'Enter a valid quantity';
        if (parseFloat(value) > maxQty) return `Cannot exceed ${maxQty}`;
      },
      showCancelButton: true,
      confirmButtonText: 'Transfer',
      confirmButtonColor: '#198754'
    });

    if (!qty) return;

    try {
      await axios.put(`${API_URL}/final-products/transfer-stock/${itemId}`, {
        qty_to_transfer: qty,
        direction
      });

      const amt = parseFloat(qty);
      setTransferredQty(prev => {
        const existing = prev[itemId] || { rAdj: 0, wAdj: 0 };
        return {
          ...prev,
          [itemId]: {
            rAdj: existing.rAdj + (direction === 'wholesale_to_retail' ? amt : -amt),
            wAdj: existing.wAdj + (direction === 'wholesale_to_retail' ? -amt : amt)
          }
        };
      });

      Swal.fire({
        icon: 'success',
        title: 'Transferred!',
        text: `${qty} units moved from ${fromLabel} to ${toLabel}`,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500
      });
    } catch (error) {
      Swal.fire('Error', error.response?.data?.message || 'Transfer failed', 'error');
    }
  };

  const effectiveSizes = (initialData.sizes && initialData.sizes.length > 0)
    ? initialData.sizes
    : (() => {
      const varsList = (initialData.variations && initialData.variations.length > 0)
        ? initialData.variations
        : (initialData.id_variation || initialData.id ? [initialData] : []);

      const sizesMap = {};
      varsList.forEach(v => {
        const vName = v.variant_name || initialData.variant_name || 'Default';
        const parts = vName.split('-');
        let size = vName;
        if (parts.length > 1) {
          const secondPart = parts[1].toUpperCase();
          if (!/^\d*(ML|GM|KG|MG|PCS|PACK|LTR)$/i.test(secondPart)) {
            size = parts[0];
          }
        }
        sizesMap[size] = sizesMap[size] || [];
        sizesMap[size].push({
          ...v,
          id_variation: v.id_variation || v.id,
          variant_name: v.variant_name || vName
        });
      });

      return Object.entries(sizesMap).map(([size, data]) => ({ size, data }));
    })();

  const effectiveColors = (initialData.colors && initialData.colors.length > 0)
    ? initialData.colors
    : (() => {
      const varsList = (initialData.variations && initialData.variations.length > 0)
        ? initialData.variations
        : (initialData.id_variation || initialData.id ? [initialData] : []);

      const colorsMap = {};
      varsList.forEach(v => {
        const vName = v.variant_name || initialData.variant_name || '';
        const parts = vName.split('-');
        if (parts[1]) {
          const color = parts[1];
          colorsMap[color] = colorsMap[color] || [];
          colorsMap[color].push({
            ...v,
            id_variation: v.id_variation || v.id,
            variant_name: v.variant_name || vName
          });
        }
      });

      return Object.entries(colorsMap).map(([color, data]) => ({ color, data }));
    })();

  const getItemAvailableQty = (item) => {
    if (!item) return 0;
    const adj = transferredQty[item.id_variation || item.id] || { rAdj: 0, wAdj: 0 };
    const effectiveRQty = Number(item.qty || 0) + adj.rAdj;
    const effectiveWQty = Number(item.current_wholesale || 0) + adj.wAdj;

    if (stockType === "Loose") {
      return Number(item.loose_qty || 0);
    } else {
      if (billType === 'Wholesale') {
        return (effectiveWQty > 0 || (item.current_wholesale !== undefined && item.current_wholesale !== null)) ? effectiveWQty : effectiveRQty;
      } else {
        return effectiveRQty;
      }
    }
  };

  const getTabTotalQty = (items) => {
    if (!items || !Array.isArray(items)) return 0;
    return items.reduce((sum, item) => sum + getItemAvailableQty(item), 0);
  };

  const unitLabel = initialData?.unit === '2' ? 'GM' : 'ML';

  const formatLooseStock = (looseQty, bottleCap, unit = unitLabel, explicitBottleCount = null) => {
    const lQty = Number(looseQty || 0);
    const cap = bottleCap > 0 ? bottleCap : (initialData?.unit === '2' ? 100 : 30);
    const numBottles = explicitBottleCount && Number(explicitBottleCount) > 0
      ? Number(explicitBottleCount)
      : Math.max(1, Math.ceil(lQty / cap));

    const bottleLabel = numBottles === 1 ? '1 Bottle' : `${numBottles} Bottles`;

    if (lQty <= 0) {
      return '0 Bottles';
    }

    // If exactly full (e.g. 1 bottle of 30ML with 30ML, or 2 bottles of 30ML with 60ML)
    if (lQty === numBottles * cap) {
      return bottleLabel;
    }

    // Partial bottle (e.g. 2 bottles but 40ML remaining of 30ML bottle -> "2 Bottles (40 ML)")
    return `${bottleLabel} (${lQty} ${unit})`;
  };

  const visibleSizes = effectiveSizes.filter(s => getTabTotalQty(s.data) > 0);
  const visibleColors = effectiveColors.filter(c => getTabTotalQty(c.data) > 0);

  useEffect(() => {
    if (mode === "size") {
      if (visibleSizes.length > 0) {
        if (!activeTab || !visibleSizes.some(s => s.size === activeTab)) {
          setActiveTab(visibleSizes[0].size);
        }
      } else {
        setActiveTab(null);
      }
    }
    if (mode === "color") {
      if (visibleColors.length > 0) {
        if (!activeTab || !visibleColors.some(c => c.color === activeTab)) {
          setActiveTab(visibleColors[0].color);
        }
      } else {
        setActiveTab(null);
      }
    }
  }, [mode, initialData, visibleSizes, visibleColors, stockType, billType, transferredQty]);

  useEffect(() => {
    const fetchDispensing = async () => {
      try {
        const res = await axios.get(`${API_URL}/dispensing-master`);
        setDispensingData(res.data || []);
      } catch (err) {
        console.error("Error fetching dispensing master:", err);
      }
    };
    fetchDispensing();

    const fetchMaterials = async () => {
      try {
        const company = JSON.parse(localStorage.getItem('company'));
        const companyId = company?.company?.id;
        if (companyId) {
          const res = await axios.get(`${API_URL}/dispense-materials/${companyId}`);
          setDispenseMaterials(res.data || []);
        }
      } catch (err) {
        console.error("Error fetching dispense materials:", err);
      }
    };
    fetchMaterials();
  }, []);

  const getBaseSize = (product) => {
    const name = product.variant_name || product.name || '';
    const match = name.match(/(\d+)(ML|GM|MG)/i);
    return match ? parseFloat(match[1]) : 100;
  };

  const buildStockMatrix = () => {
    const sizes = visibleSizes.map(s => s.size) || [];
    const colors = visibleColors || [];

    const rows = colors.map(colorObj => {
      const row = {
        color: colorObj.color,
        total: 0
      };

      sizes.forEach(size => {
        const qty = colorObj.data.filter(
          item => item.variant_name?.startsWith(size + "-")
        ).reduce((sum, item) => sum + getItemAvailableQty(item), 0);

        row[size] = qty;
        row.total += qty;
      });

      return row;
    });

    const columnTotals = {};
    sizes.forEach(size => {
      columnTotals[size] = rows.reduce((sum, r) => sum + (r[size] || 0), 0);
    });

    const grandTotal = rows.reduce((sum, r) => sum + r.total, 0);

    return { sizes, rows, columnTotals, grandTotal };
  };

  const filteredVariations = () => {
    let data = [];
    if (mode === "size") {
      data = visibleSizes.find(s => s.size === activeTab)?.data || [];
    } else if (mode === "color") {
      data = visibleColors.find(c => c.color === activeTab)?.data || [];
    }

    // Filter by stockType and strictly hide items where qty <= 0
    const filtered = data.filter(item => {
      const availQty = getItemAvailableQty(item);
      return availQty > 0;
    });

    // Sort in ascending (ASC) order as per price_date
    return filtered.sort((a, b) => {
      const dateA = a.price_date ? new Date(a.price_date).getTime() : Infinity;
      const dateB = b.price_date ? new Date(b.price_date).getTime() : Infinity;
      return dateA - dateB;
    });
  };


  const [selectedYearFilter, setSelectedYearFilter] = useState("ALL");
  const [selectedBatchFilter, setSelectedBatchFilter] = useState("ALL");

  const getItemYear = (item) => {
    if (item.year) return String(item.year);
    if (item.price_date) {
      const d = new Date(item.price_date);
      if (!isNaN(d.getFullYear())) return String(d.getFullYear());
    }
    if (item.expiry_date) {
      const d = new Date(item.expiry_date);
      if (!isNaN(d.getFullYear())) return String(d.getFullYear());
    }
    if (item.manufacturing_date) {
      const d = new Date(item.manufacturing_date);
      if (!isNaN(d.getFullYear())) return String(d.getFullYear());
    }
    if (item.createdAt) {
      const d = new Date(item.createdAt);
      if (!isNaN(d.getFullYear())) return String(d.getFullYear());
    }
    return 'Standard';
  };

  const getAvailableYears = () => {
    const vars = filteredVariations();
    const yearsSet = new Set();
    vars.forEach(item => {
      yearsSet.add(getItemYear(item));
    });
    return Array.from(yearsSet).sort((a, b) => {
      if (a === 'Standard') return 1;
      if (b === 'Standard') return -1;
      return parseInt(b) - parseInt(a);
    });
  };

  const getAvailableBatches = () => {
    const vars = filteredVariations();
    const batchSet = new Set();
    vars.forEach(item => {
      if (item.batch_no && String(item.batch_no).trim() !== '') {
        batchSet.add(String(item.batch_no).trim());
      } else {
        batchSet.add('No Batch No');
      }
    });
    return Array.from(batchSet);
  };

  const getGroupedVariations = () => {
    const vars = filteredVariations();
    const hasAnyBatch = vars.some(item => item.batch_no && String(item.batch_no).trim() !== '');

    const map = {};
    vars.forEach(item => {
      const y = getItemYear(item);
      if (selectedYearFilter !== "ALL" && y !== selectedYearFilter) return;

      const batchKey = (item.batch_no && String(item.batch_no).trim() !== '') ? String(item.batch_no).trim() : 'No Batch No';
      if (selectedBatchFilter !== "ALL" && batchKey !== selectedBatchFilter) return;

      if (!map[y]) map[y] = {};
      if (!map[y][batchKey]) map[y][batchKey] = [];
      map[y][batchKey].push(item);
    });

    const sortedYears = Object.keys(map).sort((a, b) => {
      if (a === 'Standard') return 1;
      if (b === 'Standard') return -1;
      return parseInt(b) - parseInt(a);
    });

    return { map, sortedYears, hasAnyBatch };
  };

  useEffect(() => {
    if (mode === "sales" && initialData.salesData) {
      let filtered = [...initialData.salesData];

      if (searchTerm) {
        filtered = filtered.filter(item =>
          item.invoice_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.serial_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.customer?.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }

      if (dateRange.start) {
        const startDate = new Date(dateRange.start);
        filtered = filtered.filter(item => new Date(item.date) >= startDate);
      }
      if (dateRange.end) {
        const endDate = new Date(dateRange.end);
        endDate.setHours(23, 59, 59, 999);
        filtered = filtered.filter(item => new Date(item.date) <= endDate);
      }

      setFilteredSalesData(filtered);
    }
  }, [mode, searchTerm, dateRange, initialData.salesData]);

  const getSerialCountInCart = (serial_no) => {
    let count = 0;
    cart.forEach(item => {
      item.serial_nos?.forEach(s => {

        if (s.serial_no === serial_no) count++;
      });
    });
    return count;
  };

  const handleToggleCart = ({ product, variant_id, serial_no, remove }) => {
    if (stockType === "Loose" && !remove) {
      setPendingCartData({ product, variant_id, serial_no });
      setShowDispenseModal(true);
      return;
    }

    addCart({ product, variant_id, serial_no, remove });
  };

  const confirmDispense = (dispenseRule) => {
    if (!pendingCartData || !dispenseRule) return;

    const { product, variant_id, serial_no } = pendingCartData;
    const baseSize = getBaseSize(product);

    // Parse volume consumed from string (e.g. "2ml" -> 2)
    const getMedicationVolume = (rule) => {
      if (rule.volume) {
        const match = rule.volume.match(/([\d.]+)\s*(ml)?/i);
        if (match) return parseFloat(match[1]);
      }
      return parseFloat(rule.medicationConsumed) || parseFloat(rule.rawMaterialConsumed) || 0;
    };

    const medVolume = getMedicationVolume(dispenseRule);
    let deductQty = medVolume > 0 ? medVolume : (parseFloat(dispenseRule.rawMaterialConsumed) || 1);

    // Generate name based on category
    let finalName = `${product.name}`;
    if (dispenseRule.category === 'TRITURATION') {
      const isPuria = dispenseRule.dispensingForm === 'PURIA' || dispenseRule.salesUnit === 'PURIA';
      const puriaCount = dispenseRule.puriaCount || 1;
      const sizeLabel = isPuria ? `${puriaCount} Puria${puriaCount > 1 ? 's' : ''}` : `${dispenseRule.salesSize}${dispenseRule.salesUnit || 'gm'}`;
      finalName += ` (Trituration ${dispenseRule.medicineType || ''} - ${sizeLabel})`;
      deductQty = parseFloat(dispenseRule.rawMaterialConsumed || (isPuria ? 0.769 * puriaCount : dispenseRule.salesSize) || 10);
    } else if (dispenseRule.category === 'MOTHER_TINCTURE') {
      finalName += ` (Mother Tincture - ${dispenseRule.salesSize}ml)`;
      deductQty = parseFloat(dispenseRule.rawMaterialConsumed || dispenseRule.salesSize || 10);
    } else if (dispenseRule.category === 'BIOCHEMIC') {
      finalName += ` (Biochemic - ${dispenseRule.salesSize}gm)`;
      deductQty = parseFloat(dispenseRule.rawMaterialConsumed || dispenseRule.salesSize || 10);
    } else if (dispenseRule.category === 'DILUTION_LIQUID') {
      finalName += ` (Liquid - ${dispenseRule.salesSize}ml)`;
    } else if (dispenseRule.category === 'MEDICATED_GLOBULES') {
      finalName += ` (Globules - ${dispenseRule.salesSize}gm)`;
    } else if (dispenseRule.category === 'SAC_LAC_DOSE') {
      const puriaCount = dispenseRule.puriaCount || 1;
      finalName += ` (Puria - ${dispenseRule.doseCount}${puriaCount > 1 ? ` x ${puriaCount} Purias` : ''})`;
      deductQty = parseFloat(dispenseRule.rawMaterialConsumed || (0.1 * puriaCount));
    } else if (dispenseRule.category === 'DW_DOSE') {
      finalName += ` (D/W - ${dispenseRule.doseCount})`;
    } else {
      finalName += ` (${dispenseRule.medicineType} - ${dispenseRule.salesSize}${dispenseRule.salesUnit})`;
    }

    // Calculate final price:
    // If master has sellingPrice configured (> 0), use that directly!
    let finalPrice = 0;
    if (parseFloat(dispenseRule.sellingPrice) > 0) {
      finalPrice = parseFloat(dispenseRule.sellingPrice);
    } else {
      const basePrice = billType === 'Wholesale'
        ? (product.wholesale_price !== undefined && product.wholesale_price !== null ? product.wholesale_price : (product.price || product.sale_cost || 0))
        : (product.sale_cost || product.price || 0);
      const calculatedPrice = (parseFloat(basePrice) || 0) * (baseSize > 0 ? (medVolume / baseSize) : 1);
      const materialsCost = getDispenseMaterialsCost(dispenseRule, dispenseMaterials);
      finalPrice = calculatedPrice + materialsCost;
    }

    const targetVarId = variant_id || product.id_variation || product.variation_id || product.id;
    const availableLooseStock = parseFloat(product.available_qty !== undefined ? product.available_qty : (product.loose_qty || 0));

    // Sum volume already in cart for this variation
    const currentReservedInCart = (cart || [])
      .filter(item => {
        const itemVarId = item.serial_nos?.[0]?.variant_id || item.variant_id || item.id_variation || item.id;
        return item.is_loose && String(itemVarId) === String(targetVarId);
      })
      .reduce((sum, item) => sum + (parseFloat(item.qty) || 1) * (parseFloat(item.loose_deduct_qty) || 1), 0);

    if (availableLooseStock > 0 && (currentReservedInCart + deductQty) > availableLooseStock) {
      const remainingAvail = Math.max(0, availableLooseStock - currentReservedInCart);
      const maxUnits = Math.floor(remainingAvail / deductQty);
      Swal.fire({
        icon: 'warning',
        title: 'Insufficient Loose Stock',
        text: `Cannot dispense ${deductQty} ${product.unit === '2' ? 'GM' : 'ML'}. Available stock is ${availableLooseStock} (${currentReservedInCart} already in cart). Maximum additional units: ${maxUnits}.`
      });
      return;
    }

    addCart({
      product: {
        ...product,
        qty: 1, // 1 unit sold in cart
        loose_deduct_qty: deductQty, // fractional or unit amount for inventory deduction
        name: finalName,
        sale_cost: finalPrice,
        price: finalPrice,
        dispense_info: dispenseRule,
        is_loose: true
      },
      variant_id,
      serial_no,
      remove: false
    });

    setShowDispenseModal(false);
    setPendingCartData(null);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-IN");
  };

  // DataTable columns configuration - correct format for react-data-table-component
  const columns = [
    {
      name: "Invoice No",
      selector: row => row.invoice_no,
      sortable: true,
      width: "170px",
      cell: row => <div style={{ whiteSpace: "wrap" }}>{row.invoice_no}</div>
    },
    {
      name: "Sales Date",
      selector: row => formatDate(row.date),
      sortable: true,
      cell: row => <div style={{ whiteSpace: "wrap" }}>{formatDate(row.date)}</div>
    },
    {
      name: "Customer Name",
      selector: row => row.customer?.name || "Walk-in Customer",
      sortable: true,
      cell: row => <div style={{ whiteSpace: "wrap" }}>{row.customer?.name || "Walk-in Customer"}</div>
    },
    {
      name: "Variant",
      selector: row => row.variant_name || row.serial_no,
      sortable: true,
      cell: row => <div style={{ whiteSpace: "wrap" }}>{row.variant_name || row.serial_no}</div>
    },
    {
      name: "Size",
      selector: row => row.Size,
      cell: row => <div style={{ whiteSpace: "wrap" }}>{row.Size}</div>
    },
    {
      name: "Color",
      selector: row => row.Color,
      cell: row => <div style={{ whiteSpace: "wrap" }}>{row.Color}</div>
    },
    {
      name: "Sale Amount",
      selector: row => `₹${row.amount}`,
      right: true,
      cell: row => <div style={{ whiteSpace: "wrap", textAlign: "right" }}>₹{row.amount}</div>
    },
    {
      name: "Tax",
      selector: row => `₹${row.tax}`,
      right: true,
      cell: row => <div style={{ whiteSpace: "wrap", textAlign: "right" }}>₹{row.tax}</div>
    },
    {
      name: "Discount",
      selector: row => `₹${row.discountAmount ?? 0}`,
      right: true,
      cell: row => <div style={{ whiteSpace: "wrap", textAlign: "right" }}>₹{row.discountAmount ?? 0}</div>
    },
    {
      name: "Payment Mode",
      selector: row => row.mode_of_payment,
      width: "150px",
      cell: row => <div style={{ whiteSpace: "wrap" }}>{row.mode_of_payment}</div>
    },
    {
      name: "Actions",
      cell: row => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Link
            className="btn btn-sm btn-primary"
            to={`/accounts/sales-bills?bill=${row.invoice_no}`}
          >
            Exchange / Claim
          </Link>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];




  return (
    <Modal show={show} onClose={onClose} heading={heading} size="xl">
      <div className="row">

        {/* Left Side Options */}
        <div className="col-3 border-end">
          <div
            className={`p-2 mb-2 cursor-pointer ${mode === "size" && "bg-primary text-white"}`}
            onClick={() => setMode("size")}
          >
            {initialData.product_type == 'simple' ? 'Serials' : 'Potency'}
          </div>
          {initialData.product_type == 'variants' && <div
            className={`p-2 mb-2 cursor-pointer ${mode === "color" && "bg-primary text-white"}`}
            onClick={() => setMode("color")}
          >
            Color
          </div>}
          <div
            className={`p-2 mb-2 cursor-pointer ${mode === "sales" && "bg-primary text-white"}`}
            onClick={() => setMode("sales")}
          >
            Sales Information
          </div>
          <div
            className={`p-2 cursor-pointer ${mode === "stock" && "bg-primary text-white"}`}
            onClick={() => setMode("stock")}
          >
            Stock
          </div>
        </div>

        {/* Right Side */}
        <div className="col-9">

          {/* Size/Color Tabs */}
          {mode !== "sales" && mode !== 'stock' && (
            <div className="mb-3 d-flex gap-2 flex-wrap align-items-center">
              {/* Sealed/Loose Tabs */}
              {hasSealedStock && hasLooseStock && !initialData?.product_value_type ? (
                <div className="btn-group me-3" role="group">
                  <button
                    type="button"
                    className={`btn btn-sm ${stockType === "Sealed" ? "btn-dark" : "btn-outline-dark"}`}
                    onClick={() => setStockType("Sealed")}
                  >
                    Sealed
                  </button>
                  <button
                    type="button"
                    className={`btn btn-sm ${stockType === "Loose" ? "btn-dark" : "btn-outline-dark"}`}
                    onClick={() => setStockType("Loose")}
                  >
                    Loose
                  </button>
                </div>
              ) : (
                <div className="me-3">
                  <span
                    className={`badge ${stockType === "Loose" ? "bg-warning text-dark border border-warning" : "bg-dark text-white"} px-3 py-2 fw-bold`}
                    style={{ fontSize: "0.85rem", letterSpacing: "0.5px" }}
                  >
                    {stockType === "Loose" ? "LOOSE MEDICINE" : "SEALED PRODUCT"}
                  </span>
                </div>
              )}

              {mode === "size" && (
                visibleSizes.length === 0 ? (
                  <span className="badge bg-danger text-white px-3 py-2 fw-semibold">
                    Out of Stock
                  </span>
                ) : (
                  visibleSizes.map((s, i) => {
                    const totalQty = getTabTotalQty(s.data);
                    const cap = s.data.length > 0 ? getBaseSize(s.data[0]) : (initialData?.unit === '2' ? 100 : 30);
                    const stockLabel = stockType === "Loose"
                      ? formatLooseStock(totalQty, cap, unitLabel)
                      : `Qty: ${totalQty}`;
                    return (
                      <button
                        key={i}
                        className={`btn ${activeTab === s.size ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => setActiveTab(s.size)}
                      >
                        {initialData.product_type == 'simple' ? 'Serials' : 'Potency'}: {s.size} ({stockLabel})
                      </button>
                    );
                  })
                )
              )}

              {mode === "color" && (
                visibleColors.length === 0 ? (
                  <span className="badge bg-danger text-white px-3 py-2 fw-semibold">
                    Out of Stock
                  </span>
                ) : (
                  visibleColors.map((c, i) => {
                    const totalQty = getTabTotalQty(c.data);
                    const cap = c.data.length > 0 ? getBaseSize(c.data[0]) : (initialData?.unit === '2' ? 100 : 30);
                    const stockLabel = stockType === "Loose"
                      ? formatLooseStock(totalQty, cap, unitLabel)
                      : `Qty: ${totalQty}`;
                    return (
                      <button
                        key={i}
                        className={`btn ${activeTab === c.color ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => setActiveTab(c.color)}
                      >
                        Color: {c.color} ({stockLabel})
                      </button>
                    );
                  })
                )
              )}
            </div>
          )}

          {/* Year & Batch Filter Bars */}
          {mode !== "sales" && mode !== 'stock' && (
            <div className="mb-3 d-flex flex-column gap-2 bg-light p-2 rounded">
              {getAvailableYears().length > 1 && (
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span className="fw-bold text-muted small me-1">Year Filter:</span>
                  <button
                    className={`btn btn-sm ${selectedYearFilter === "ALL" ? "btn-primary" : "btn-outline-secondary"}`}
                    onClick={() => setSelectedYearFilter("ALL")}
                  >
                    All Years
                  </button>
                  {getAvailableYears().map((year, yIdx) => (
                    <button
                      key={yIdx}
                      className={`btn btn-sm ${selectedYearFilter === year ? "btn-primary" : "btn-outline-secondary"}`}
                      onClick={() => setSelectedYearFilter(year)}
                    >
                      Year {year}
                    </button>
                  ))}
                </div>
              )}

              {getAvailableBatches().length > 1 && (
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span className="fw-bold text-muted small me-1">Batch Filter:</span>
                  <button
                    className={`btn btn-sm ${selectedBatchFilter === "ALL" ? "btn-warning text-dark" : "btn-outline-secondary"}`}
                    onClick={() => setSelectedBatchFilter("ALL")}
                  >
                    All Batches
                  </button>
                  {getAvailableBatches().map((batch, bIdx) => (
                    <button
                      key={bIdx}
                      className={`btn btn-sm ${selectedBatchFilter === batch ? "btn-warning text-dark fw-bold" : "btn-outline-secondary"}`}
                      onClick={() => setSelectedBatchFilter(batch)}
                    >
                      {batch === 'No Batch No' ? 'No Batch No' : `Batch: ${batch}`}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Variations Grouped Year & Batch-Wise */}
          {mode !== "sales" && mode !== 'stock' && (() => {
            const { map, sortedYears, hasAnyBatch } = getGroupedVariations();

            if (sortedYears.length === 0) {
              return <div className="text-center py-4 text-muted">No variations found for the selected filter.</div>;
            }

            return (
              <div>
                {sortedYears.map((year, yIdx) => {
                  const totalYearVars = Object.values(map[year]).reduce((acc, arr) => acc + arr.length, 0);
                  const batchKeys = Object.keys(map[year]);

                  return (
                    <div className="mb-4" key={yIdx}>
                      <div className="d-flex align-items-center mb-3 pb-1 border-bottom border-2 border-primary">
                        <h6 className="fw-bold text-primary mb-0 me-2">
                          Year: {year}
                        </h6>
                        <span className="badge bg-primary rounded-pill">
                          {totalYearVars} variation{totalYearVars > 1 ? 's' : ''}
                        </span>
                      </div>

                      {batchKeys.map((batchKey, bIdx) => {
                        const batchExpDate = map[year][batchKey].find(d => d.exp_date)?.exp_date;
                        return (
                          <div className="mb-3 ps-2 border-start border-3 border-warning" key={bIdx}>
                            <div className="d-flex align-items-center mb-2">
                              <span className={`badge ${batchKey === 'No Batch No' ? 'bg-secondary' : 'bg-warning text-dark border border-warning'} me-2 px-2 py-1`}>
                                {batchKey === 'No Batch No' ? 'No Batch No' : `Batch No: ${batchKey}`}
                              </span>
                              {batchExpDate && (
                                <span className="badge bg-light text-danger border border-danger me-2 px-2 py-1">
                                  Exp: {new Date(batchExpDate).toLocaleDateString('en-IN')}
                                </span>
                              )}
                              <span className="text-muted small">
                                ({map[year][batchKey].length} variant{map[year][batchKey].length > 1 ? 's' : ''})
                              </span>
                            </div>

                            <div className="row">
                              {map[year][batchKey].map((data, index) => {
                                const serialToUse = stockType === "Loose" ? `LOOSE-${data.serial_no || index}` : data.serial_no;
                                const countInCart = getSerialCountInCart(serialToUse);
                                const wQty = Number(data.current_wholesale || 0);
                                const rQty = Number(data.qty || 0);
                                const adj = transferredQty[data.id_variation || data.id] || { rAdj: 0, wAdj: 0 };
                                const effectiveRQty = rQty + adj.rAdj;
                                const effectiveWQty = wQty + adj.wAdj;
                                const displayQty = stockType === "Sealed"
                                  ? (billType === 'Wholesale' ? effectiveWQty : effectiveRQty)
                                  : Number(data.loose_qty || 0);

                                const parentName = initialData?.name || initialData?.product_name || '';
                                const variantName = data.variant_name || '';
                                const fullProductName = parentName
                                  ? (variantName ? `${parentName} (${variantName})` : parentName)
                                  : (variantName || 'Product');
                                const unitPrice = billType === 'Wholesale' ? (data.wholesale_price || data.price || initialData?.sale_cost || 0) : (data.price || initialData?.sale_cost || 0);
                                const unitLabel = initialData?.unit === '2' ? 'GM' : 'ML';
                                const bottleSizeLabel = data.segment || (initialData?.unit === '2' ? '100gm' : (data.variant_name === '10M' || data.variant_name === '50M' || data.variant_name === 'CM' ? '10ML' : '30ML'));

                                return (
                                  <div className="col-md-6 mb-3" key={index}>
                                    <div
                                      className={`card h-100 border p-3 ${countInCart > 0 ? 'border-primary bg-light-primary' : 'bg-white'}`}
                                      style={{ borderRadius: '8px', cursor: 'pointer', transition: 'all 0.2s ease-in-out', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}
                                      onClick={() => handleToggleCart({
                                        product: {
                                          ...initialData,
                                          ...data,
                                          id: initialData?.id || data.id,
                                          variation_id: data.id_variation || data.id,
                                          name: fullProductName,
                                          product_name: fullProductName,
                                          variant_name: variantName,
                                          batch_no: data.batch_no || '',
                                          exp_date: data.exp_date || '',
                                          price: data.price || initialData?.price || initialData?.sale_cost || 0,
                                          wholesale_price: data.wholesale_price || initialData?.wholesale_price || 0,
                                          sale_cost: unitPrice,
                                          hsn_sac: data.hsn_sac || data.hsn_code || data.hsn || data.taxes?.hsn_code || initialData?.hsn_sac || initialData?.hsn_code || initialData?.taxes?.hsn_code || '',
                                          qty: stockType === "Loose" ? 1 : data.qty,
                                          bottle_qty: data.qty || 1,
                                          loose_qty: Number(data.loose_qty || 0),
                                          available_qty: stockType === "Loose" ? Number(data.loose_qty || 0) : displayQty,
                                          size: bottleSizeLabel,
                                          is_loose: stockType === "Loose"
                                        },
                                        variant_id: data.id_variation || data.id,
                                        serial_no: serialToUse,
                                        remove: false
                                      })}
                                    >
                                      <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                          <h6 className="fw-bold text-dark mb-1" style={{ color: '#1e293b', fontSize: '16px' }}>
                                            {data.variant_name} {data.serial_no ? <span className="text-muted" style={{ fontSize: "14px" }}>({data.serial_no})</span> : ''}
                                          </h6>
                                          <div className="d-flex flex-wrap gap-2 align-items-center mt-2">
                                            <span className="badge bg-primary px-2 py-1" style={{ fontSize: "15px" }}>
                                              ₹{unitPrice}
                                            </span>
                                            {stockType === "Loose" && (
                                              <span className="badge bg-info text-dark border px-2 py-1 fw-semibold">
                                                Size: {bottleSizeLabel}
                                              </span>
                                            )}
                                            <span className="badge bg-dark text-white px-2 py-1 fw-semibold">
                                              Year: {year}
                                            </span>
                                            {data.batch_no ? (
                                              <span className="badge bg-warning text-dark border border-warning px-2 py-1 fw-semibold">
                                                Batch No: {data.batch_no}
                                              </span>
                                            ) : (
                                              <span className="badge bg-secondary text-white px-2 py-1">
                                                No Batch No
                                              </span>
                                            )}
                                            {data.exp_date && (
                                              <span className="badge bg-light text-danger border border-danger px-2 py-1 fw-semibold">
                                                Exp: {new Date(data.exp_date).toLocaleDateString('en-IN')}
                                              </span>
                                            )}
                                            {data.price_date && (
                                              <span className="badge bg-light text-dark border px-2 py-1">
                                                Date: {new Date(data.price_date).toLocaleDateString('en-IN')}
                                              </span>
                                            )}
                                          </div>
                                        </div>

                                        <div className="text-end">
                                          <span className="badge bg-success text-white px-2 py-1 d-block mb-1">
                                            {stockType === "Loose"
                                              ? `Stock: ${formatLooseStock(data.loose_qty, getBaseSize(data), unitLabel, data.qty)}`
                                              : `Stock: ${displayQty}`}
                                          </span>
                                          {countInCart > 0 && (
                                            <span className="badge bg-info text-white d-block">
                                              In Cart: {countInCart}
                                            </span>
                                          )}
                                          {stockType === "Sealed" && (
                                            <div className="d-flex gap-1 mt-1">
                                              {effectiveWQty > 0 && (
                                                <button
                                                  className="btn btn-outline-success py-0 px-1"
                                                  style={{ fontSize: '0.65rem' }}
                                                  onClick={(e) => handleStockTransfer(data, 'wholesale_to_retail', e)}
                                                  title="Transfer Wholesale → Retail"
                                                >
                                                  W→R
                                                </button>
                                              )}
                                              {effectiveRQty > 0 && (
                                                <button
                                                  className="btn btn-outline-warning py-0 px-1"
                                                  style={{ fontSize: '0.65rem' }}
                                                  onClick={(e) => handleStockTransfer(data, 'retail_to_wholesale', e)}
                                                  title="Transfer Retail → Wholesale"
                                                >
                                                  R→W
                                                </button>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            );
          })()}

          {/* Sales Data Mode */}
          {mode === "sales" && mode !== 'stock' && (
            <div>
              {/* Filters */}
              <div className="mb-3 p-3 bg-light rounded">
                <div className="row g-2">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search invoice, serial, customer..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Start Date"
                      value={dateRange.start}
                      onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="End Date"
                      value={dateRange.end}
                      onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
                    />
                  </div>
                  <div className="col-md-3">
                    <button
                      className="btn btn-secondary w-100"
                      onClick={() => {
                        setSearchTerm("");
                        setDateRange({ start: "", end: "" });
                      }}
                    >
                      Clear Filters
                    </button>
                  </div>
                </div>
              </div>

              {/* DataTable */}
              <DataTable
                columns={columns}
                data={filteredSalesData}
                striped
                highlightOnHover
                pointerOnHover
                pagination
                customStyles={customTableStyles}
                noDataComponent="No sales records found"
              />

              <div className="mt-2 text-muted small">
                Showing {filteredSalesData.length} of {initialData.salesData?.length || 0} records
              </div>
            </div>
          )}

          {mode === 'stock' && (
            <div className="table-responsive mb-4">
              {(() => {
                const { sizes, rows, columnTotals, grandTotal } = buildStockMatrix();

                return (
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th rowSpan="2">Picture</th>
                        <th rowSpan="2">Colour</th>
                        <th colSpan={sizes.length} style={{ textAlign: 'center' }}>Size</th>
                        <th rowSpan="2">Sub Total</th>
                      </tr>
                      <tr>
                        {sizes.map(size => (
                          <th key={size}>{size}</th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={index}>
                          {/* Picture only once */}
                          {index === 0 && (
                            <td rowSpan={rows.length}>
                              <img
                                src={`${API_URL}/${initialData.product_image}`}
                                alt={initialData.name}
                                className="card-img-top mx-auto"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = './logo.png'; // fallback logo on load error
                                }}
                                style={{ width: "100%", height: 40, objectFit: 'contain', }}
                              />
                            </td>
                          )}

                          <td className="fw-bold">{row.color}</td>

                          {sizes.map(size => (
                            <td key={size}>{row[size]}</td>
                          ))}

                          <td className="fw-bold">{row.total}</td>
                        </tr>
                      ))}
                    </tbody>

                    <tfoot className="fw-bold">
                      <tr>
                        <td ></td>
                        <td >Total</td>
                        {sizes.map(size => (
                          <td key={size}>{columnTotals[size]}</td>
                        ))}
                        <td>{grandTotal}</td>
                      </tr>
                    </tfoot>
                  </table>
                );
              })()}
            </div>
          )}

        </div>
      </div>
      <DispenseSelectionModal
        show={showDispenseModal}
        onClose={() => setShowDispenseModal(false)}
        dispensingData={dispensingData}
        dispenseMaterials={dispenseMaterials}
        onSelect={confirmDispense}
        productType={initialData.product_contain_type}
        pendingData={pendingCartData}
      />
    </Modal>
  );
};

const TRITURATION_FALLBACK_RATES = {
  'Category A': { '10gm': 60, '15gm': 90, '20gm': 104.5, '30gm': 150, '60gm': 240, '100gm': 390, 'Puria': 12 },
  'Category B': { '10gm': 80.5, '15gm': 115, '20gm': 150, '30gm': 200, '60gm': 340, '100gm': 550, 'Puria': 12 },
  'Category C': { '10gm': 99.67, '15gm': 160, '20gm': 180, '30gm': 270, '60gm': 430, '100gm': 650, 'Puria': 14 },
  'Category D': { '10gm': 140, '15gm': 230, '20gm': 260, '30gm': 350, '60gm': 600, '100gm': 720, 'Puria': 14 },
  'Category E': { '10gm': 190, '15gm': 300, '20gm': 350, '30gm': 510, '60gm': 820, '100gm': 1000, 'Puria': 16 },
  'Category F': { '10gm': 260, '15gm': 390, '20gm': 490, '30gm': 680, '60gm': 1100, '100gm': 1800, 'Puria': 16 }
};

const TRITURATION_CATS = ['Category A', 'Category B', 'Category C', 'Category D', 'Category E', 'Category F'];
const TRIT_SIZES = ['10gm', '15gm', '20gm', '30gm', '60gm', '100gm', 'Puria'];
const MT_GROUPS = ['Group A', 'Group B', 'Group C', 'Group D', 'Group E', 'Group F', 'Group G', 'Group H', 'Group I', 'Group J'];
const MT_SIZES = ['5ml', '10ml', '15ml', '20ml', '30ml', '60ml', '100ml'];
const LIQUID_POTENCY_GROUPS = ['3, 6, 12, 30', '3X & 200', '1M'];
const GLOBULE_POTENCY_GROUPS = ['3, 6, 12, 30', '3X & 200', '1M', '10M', '50M', 'CM'];

const PURIA_DOCTORS = [
  { id: 'STANDARD', label: '1 S/M Dose (Standard)', desc: 'Up to 30, 200, 1M, 10M, 50M/CM' },
  { id: 'KKG', label: 'Doctor KKG', desc: '200, 1M' },
  { id: 'SKM', label: 'Doctor SKM / SKD', desc: 'Up to 1M' },
  { id: 'LM', label: 'Other Puria', desc: '1M/0, 10M/0, 50M/0, CM/0' },
];

const PURIA_RATES = {
  STANDARD: [
    { doseCount: '1 S/M Dose (Up to 30)', label: 'Up to 30 (LP)', price: 9, description: '1 S/M Dose (Up to 30 Potency)' },
    { doseCount: '1 Dose (200)', label: '200', price: 10, description: '1 Dose (200 Potency)' },
    { doseCount: '1 Dose (1M)', label: '1M', price: 12, description: '1 Dose (1M Potency)' },
    { doseCount: '1 Dose (10M)', label: '10M', price: 23, description: '1 Dose (10M Potency)' },
    { doseCount: '1 Dose (50M/CM)', label: '50M / CM', price: 36, description: '1 Dose (50M & CM Potency)' },
  ],
  KKG: [
    { doseCount: 'KKG 200', label: '200 (KKG)', price: 12, description: 'KKG 200 Puria' },
    { doseCount: 'KKG 1M', label: '1M (KKG)', price: 14, description: 'KKG 1M Puria' },
  ],
  SKM: [
    { doseCount: 'SKM/SKD Up to 1M', label: 'Up to 1M (SKM/SKD)', price: 7, description: 'SKM/SKD Up to 1M Puria' },
  ],
  LM: [
    { doseCount: '1M/0 (All)', label: '1M/0 (All)', price: 10, description: '1M/0 Puria' },
    { doseCount: '10M/0 (Up to 10 doses)', label: '10M/0 (≤10 doses)', price: 20, description: '10M/0 Puria (Up to 10 doses)' },
    { doseCount: '50M/0 (Up to 10 doses)', label: '50M/0 (≤10 doses)', price: 30, description: '50M/0 Puria (Up to 10 doses)' },
    { doseCount: 'CM/0 (Up to 10 doses)', label: 'CM/0 (≤10 doses)', price: 30, description: 'CM/0 Puria (Up to 10 doses)' },
    { doseCount: '10M/0 (> 10 doses)', label: '10M/0 (>10 doses)', price: 18, description: '10M/0 Puria (> 10 doses)' },
    { doseCount: '50M/0 (> 10 doses)', label: '50M/0 (>10 doses)', price: 22, description: '50M/0 Puria (> 10 doses)' },
    { doseCount: 'CM/0 (> 10 doses)', label: 'CM/0 (>10 doses)', price: 22, description: 'CM/0 Puria (> 10 doses)' },
  ]
};

const detectPotencyGroup = (nameOrVariant) => {
  if (!nameOrVariant) return '3, 6, 12, 30';
  const str = nameOrVariant.toString().toUpperCase().trim();
  if (str === 'CM' || str.endsWith(' CM') || str.includes(' CM ') || str.startsWith('CM ')) return 'CM';
  if (str === '50M' || str.endsWith(' 50M') || str.includes(' 50M ') || str.startsWith('50M ')) return '50M';
  if (str === '10M' || str.endsWith(' 10M') || str.includes(' 10M ') || str.startsWith('10M ')) return '10M';
  if (str === '1M' || str.endsWith(' 1M') || str.includes(' 1M ') || str.startsWith('1M ') || str.includes('1000')) return '1M';
  if (str === '200' || str === '200C' || str === '200CH' || str === '3X' || str.endsWith(' 200') || str.endsWith(' 3X') || str.includes('200') || str.includes('3X')) return '3X & 200';
  return '3, 6, 12, 30';
};

const detectProductTypeInfo = (product, productType) => {
  const p = product || {};
  const sku = (p.sku || '').toUpperCase();
  const containType = (p.product_contain_type || productType || '').toUpperCase();
  const cat = (p.category_name || p.category || p.final_category || '').toString().toUpperCase();
  const name = (p.name || p.product_name || '').toUpperCase();
  const variant = (p.variant_name || '').toUpperCase().trim();
  const remarks = (p.remarks || '').trim();
  const segment = (p.segment || '').trim();
  const subSegment = (p.subSegment || '').trim();

  // 1. Mother Tinctures
  const isMT =
    sku.startsWith('WSI-MT-') ||
    sku.startsWith('JNM-MT-') ||
    sku.includes('-MT-') ||
    containType === 'MOTHER TINCTURES' ||
    containType === 'MT' ||
    cat === 'MOTHER TINCTURES' ||
    cat === 'BRANDED MOTHER TINCTURES' ||
    cat === 'MT' ||
    variant === 'Q' ||
    variant === 'MOTHER TINCTURE' ||
    variant === 'MT' ||
    name.includes('MOTHER TINCTURE') ||
    name.endsWith(' Q') ||
    name.includes(' Q ') ||
    /^GROUP\s+[A-J]$/i.test(remarks) ||
    /^GROUP\s+[A-J]$/i.test(segment);

  if (isMT) {
    let mtGroup = 'Group A';
    let isLocked = false;
    for (const s of [remarks, segment, subSegment]) {
      if (/^Group\s+[A-J]$/i.test(s)) {
        mtGroup = `Group ${s.split(/\s+/)[1].toUpperCase()}`;
        isLocked = true;
        break;
      }
      if (/^[A-J]$/i.test(s)) {
        mtGroup = `Group ${s.toUpperCase()}`;
        isLocked = true;
        break;
      }
    }
    return {
      type: 'MOTHER_TINCTURE',
      label: 'Mother Tincture (Q)',
      allowedTabs: ['MOTHER_TINCTURE', 'SAC_LAC_DOSE'],
      defaultTab: 'MOTHER_TINCTURE',
      detectedMTGroup: mtGroup,
      isMTGroupLocked: isLocked,
      detectedTritCat: 'Category A',
      isTritCatLocked: false,
      detectedPotency: '3, 6, 12, 30',
      isPotencyLocked: false
    };
  }

  // 2. Biochemics & Biocombinations
  const isBiochem =
    sku.startsWith('WSI-BIOCHEM-') ||
    sku.startsWith('WSI-BIOCOMB-') ||
    sku.startsWith('JNM-BIOCHEM-') ||
    sku.startsWith('JNM-BIOCOMB-') ||
    containType.includes('BIOCHEM') ||
    containType.includes('BIOCOMB') ||
    cat.includes('BIOCHEM') ||
    cat.includes('BIOCOMB') ||
    name.startsWith('BIOCOMBINATION') ||
    name.includes('BIOCHEMIC');

  if (isBiochem) {
    return {
      type: 'BIOCHEMIC',
      label: name.startsWith('BIOCOMBINATION') ? 'Biocombination' : 'Biochemic',
      allowedTabs: ['BIOCHEMIC', 'SAC_LAC_DOSE'],
      defaultTab: 'BIOCHEMIC',
      detectedMTGroup: 'Group A',
      isMTGroupLocked: false,
      detectedTritCat: 'Category A',
      isTritCatLocked: false,
      detectedPotency: '3, 6, 12, 30',
      isPotencyLocked: false
    };
  }

  // 3. Triturations
  const isTrit =
    sku.startsWith('JNM-TRI-') ||
    sku.startsWith('WSI-TRI-') ||
    containType.includes('TRITURATION') ||
    cat.includes('TRITURATION') ||
    cat === 'TABLETS' ||
    /^CATEGORY\s+[A-F]$/i.test(remarks) ||
    /^CATEGORY\s+[A-F]$/i.test(segment) ||
    name.includes('TRITURATION');

  if (isTrit) {
    let tritCat = 'Category A';
    let isLocked = false;
    for (const s of [remarks, segment, subSegment]) {
      if (/^Category\s+[A-F]$/i.test(s)) {
        tritCat = `Category ${s.split(/\s+/)[1].toUpperCase()}`;
        isLocked = true;
        break;
      }
      if (/^[A-F]$/i.test(s)) {
        tritCat = `Category ${s.toUpperCase()}`;
        isLocked = true;
        break;
      }
    }
    return {
      type: 'TRITURATION',
      label: 'Trituration Tablets',
      allowedTabs: ['TRITURATION', 'SAC_LAC_DOSE'],
      defaultTab: 'TRITURATION',
      detectedMTGroup: 'Group A',
      isMTGroupLocked: false,
      detectedTritCat: tritCat,
      isTritCatLocked: isLocked,
      detectedPotency: '3, 6, 12, 30',
      isPotencyLocked: false
    };
  }

  // 4. Dilutions
  let potency = '3, 6, 12, 30';
  let isPotencyLocked = false;
  if (variant) {
    if (variant === 'CM' || variant.includes('CM')) {
      potency = 'CM';
      isPotencyLocked = true;
    } else if (variant === '50M' || variant.includes('50M')) {
      potency = '50M';
      isPotencyLocked = true;
    } else if (variant === '10M' || variant.includes('10M')) {
      potency = '10M';
      isPotencyLocked = true;
    } else if (variant === '1M' || variant === '1000' || variant.includes('1M')) {
      potency = '1M';
      isPotencyLocked = true;
    } else if (variant === '200' || variant === '200C' || variant === '200CH' || variant === '3X' || variant.includes('200')) {
      potency = '3X & 200';
      isPotencyLocked = true;
    } else if (['3', '6', '12', '30', '30C', '30CH', '6C', '12C'].includes(variant) || variant.includes('30')) {
      potency = '3, 6, 12, 30';
      isPotencyLocked = true;
    }
  }

  const isDilution =
    sku.startsWith('WSI-DIL-') ||
    sku.startsWith('JNM-DIL-') ||
    containType.includes('DILUTION') ||
    cat.includes('DILUTION') ||
    name.includes('DILUTION') ||
    isPotencyLocked;

  if (isDilution) {
    return {
      type: 'DILUTION',
      label: `Dilution (${variant || 'Standard'})`,
      allowedTabs: ['DILUTION_LIQUID', 'MEDICATED_GLOBULES', 'SAC_LAC_DOSE', 'DW_DOSE'],
      defaultTab: 'DILUTION_LIQUID',
      detectedMTGroup: 'Group A',
      isMTGroupLocked: false,
      detectedTritCat: 'Category A',
      isTritCatLocked: false,
      detectedPotency: potency,
      isPotencyLocked: isPotencyLocked
    };
  }

  return {
    type: 'UNKNOWN',
    label: 'Loose Product',
    allowedTabs: ['TRITURATION', 'DILUTION_LIQUID', 'MEDICATED_GLOBULES', 'SAC_LAC_DOSE', 'DW_DOSE', 'MOTHER_TINCTURE', 'BIOCHEMIC'],
    defaultTab: 'DILUTION_LIQUID',
    detectedMTGroup: 'Group A',
    isMTGroupLocked: false,
    detectedTritCat: 'Category A',
    isTritCatLocked: false,
    detectedPotency: potency,
    isPotencyLocked: false
  };
};

const DispenseSelectionModal = ({ show, onClose, dispensingData, dispenseMaterials, onSelect, productType, pendingData }) => {
  const typeInfo = detectProductTypeInfo(pendingData?.product, productType);

  const [activeTabState, setActiveTabState] = useState(typeInfo.defaultTab);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedDoseCount, setSelectedDoseCount] = useState(null);
  const [selectedTritCategory, setSelectedTritCategory] = useState(typeInfo.detectedTritCat);
  const [selectedMTGroup, setSelectedMTGroup] = useState(typeInfo.detectedMTGroup);
  const [selectedPotencyGroup, setSelectedPotencyGroup] = useState(typeInfo.detectedPotency);

  // Puria Specific States
  const [puriaCount, setPuriaCount] = useState(1);
  const [selectedPuriaDoctor, setSelectedPuriaDoctor] = useState('STANDARD');
  const [selectedPuriaDose, setSelectedPuriaDose] = useState('1 S/M Dose (Up to 30)');

  // Categories definition
  const categories = [
    { key: "TRITURATION", label: "💊 Trituration", desc: "Size conversion Apr. 24 (Cats A-F)" },
    { key: "DILUTION_LIQUID", label: "💧 Liquid Dilution", desc: "Spirit-based liquid dilution" },
    { key: "MEDICATED_GLOBULES", label: "🍬 Medicated Globules", desc: "Dilution added to globules" },
    { key: "SAC_LAC_DOSE", label: "✉️ Sac Lac Dose (Puria)", desc: "Sugar powder packets" },
    { key: "DW_DOSE", label: "🚰 Distilled Water Dose", desc: "D/W bottle doses" },
    { key: "MOTHER_TINCTURE", label: "🧪 Mother Tincture", desc: "Groups A to J prices" },
    { key: "BIOCHEMIC", label: "🌿 Biochemic", desc: "Biochemic 3X-30X tablets" },
  ];

  // Set category tab and pre-select configuration when modal opens or pending product changes
  useEffect(() => {
    if (show) {
      const info = detectProductTypeInfo(pendingData?.product, productType);
      setActiveTabState(info.defaultTab);
      setSelectedPotencyGroup(info.detectedPotency);
      setSelectedTritCategory(info.detectedTritCat);
      setSelectedMTGroup(info.detectedMTGroup);
      setPuriaCount(1);

      // Auto detect Puria dose & doctor from variant
      const varName = (pendingData?.product?.variant_name || '').toUpperCase().trim();
      if (varName.startsWith('0/') || varName.includes('/0')) {
        setSelectedPuriaDoctor('LM');
        setSelectedPuriaDose('1M/0 (All)');
      } else if (varName.includes('200')) {
        setSelectedPuriaDoctor('STANDARD');
        setSelectedPuriaDose('1 Dose (200)');
      } else if (varName.includes('1M') && !varName.includes('10M')) {
        setSelectedPuriaDoctor('STANDARD');
        setSelectedPuriaDose('1 Dose (1M)');
      } else if (varName.includes('10M')) {
        setSelectedPuriaDoctor('STANDARD');
        setSelectedPuriaDose('1 Dose (10M)');
      } else if (varName.includes('50M') || varName.includes('CM')) {
        setSelectedPuriaDoctor('STANDARD');
        setSelectedPuriaDose('1 Dose (50M/CM)');
      } else {
        setSelectedPuriaDoctor('STANDARD');
        setSelectedPuriaDose('1 S/M Dose (Up to 30)');
      }

      if (info.type === 'TRITURATION') {
        setSelectedSize('10gm');
      } else if (info.type === 'MOTHER_TINCTURE') {
        setSelectedSize('30ml');
      } else if (info.type === 'BIOCHEMIC') {
        setSelectedSize('30gm');
      } else {
        setSelectedSize('30ml');
      }
    }
  }, [show, pendingData, productType]);

  const tabRules = dispensingData.filter(rule => rule.category === activeTabState);

  // Auto-select defaults on tab change or potency change
  useEffect(() => {
    if (activeTabState === 'TRITURATION') {
      if (!selectedSize || !TRIT_SIZES.includes(selectedSize)) {
        setSelectedSize('10gm');
      }
    } else if (activeTabState === 'MOTHER_TINCTURE') {
      if (!selectedSize || !MT_SIZES.includes(selectedSize)) {
        setSelectedSize('30ml');
      }
    } else if (activeTabState === 'DILUTION_LIQUID' || activeTabState === 'MEDICATED_GLOBULES') {
      const validRules = tabRules.filter(r => r.medicineType === selectedPotencyGroup);
      const available = validRules.map(r => r.salesSize);
      if (available.length > 0) {
        if (!selectedSize || !available.some(s => parseFloat(s) === parseFloat(selectedSize))) {
          const defaultRule = validRules.find(r => parseFloat(r.salesSize) === (activeTabState === 'MEDICATED_GLOBULES' ? 15 : 30)) || validRules[0];
          setSelectedSize(defaultRule.salesSize);
        }
      } else if (tabRules.length > 0) {
        setSelectedSize(tabRules[0].salesSize);
      }
    } else if (activeTabState === 'BIOCHEMIC') {
      if (tabRules.length > 0) {
        const defaultRule = tabRules.find(r => parseFloat(r.salesSize) === 30) || tabRules[0];
        setSelectedSize(defaultRule.salesSize);
      } else if (!selectedSize) {
        setSelectedSize('30gm');
      }
    } else if (activeTabState === 'SAC_LAC_DOSE') {
      const validDoses = PURIA_RATES[selectedPuriaDoctor] || [];
      if (!validDoses.some(d => d.doseCount === selectedPuriaDose)) {
        if (validDoses.length > 0) {
          setSelectedPuriaDose(validDoses[0].doseCount);
        }
      }
    } else {
      if (tabRules.length > 0) {
        setSelectedDoseCount(tabRules[0].doseCount);
      }
    }
  }, [activeTabState, selectedPotencyGroup, selectedPuriaDoctor, dispensingData]);

  if (!show) return null;

  // Active rule lookup
  let activeRule = null;
  const safePuriaCount = Math.max(1, parseInt(puriaCount) || 1);

  if (activeTabState === 'TRITURATION') {
    const isPuria = selectedSize === 'Puria';
    const numSize = parseFloat(selectedSize) || 10;

    if (isPuria) {
      const fallbackPrice = TRITURATION_FALLBACK_RATES[selectedTritCategory]?.[selectedSize] || 12;
      const dbRule = tabRules.find(r => r.medicineType === selectedTritCategory && (r.dispensingForm === 'PURIA' || r.salesUnit === 'PURIA'));
      const unitPrice = dbRule && parseFloat(dbRule.sellingPrice) > 0 ? parseFloat(dbRule.sellingPrice) : fallbackPrice;

      activeRule = {
        category: 'TRITURATION',
        medicineType: selectedTritCategory,
        dispensingForm: 'PURIA',
        salesSize: safePuriaCount,
        salesUnit: 'PURIA',
        puriaCount: safePuriaCount,
        puriaQty: safePuriaCount,
        unitSellingPrice: unitPrice,
        sellingPrice: unitPrice * safePuriaCount,
        rawMaterialConsumed: +(0.769 * safePuriaCount).toFixed(3),
        rawMaterialUnit: 'GM',
        whiteCapQty: 0,
        bottleSize: null,
        labelSize: null,
        doseCount: `${safePuriaCount} Puria${safePuriaCount > 1 ? 's' : ''}`,
        description: `Trituration ${selectedTritCategory} - ${safePuriaCount} Puria${safePuriaCount > 1 ? 's' : ''} (wef 01.04.26)`
      };
    } else {
      activeRule = tabRules.find(r =>
        r.medicineType === selectedTritCategory && parseFloat(r.salesSize) === numSize
      );

      // If not in database dispensingData, synthesize from standard CNT1 Trituration table
      if (!activeRule) {
        const fallbackPrice = TRITURATION_FALLBACK_RATES[selectedTritCategory]?.[selectedSize] || 60;
        activeRule = {
          category: 'TRITURATION',
          medicineType: selectedTritCategory,
          dispensingForm: 'TRITURATION',
          salesSize: numSize,
          salesUnit: 'GM',
          rawMaterialConsumed: numSize,
          rawMaterialUnit: 'GM',
          sellingPrice: fallbackPrice,
          bottleSize: numSize === 10 ? '15ML' : (numSize <= 20 ? '30ML' : (numSize === 30 ? '32ML' : (numSize === 60 ? '60ML' : '100ML'))),
          labelSize: numSize === 10 ? '10ML' : (numSize <= 20 ? '22ML' : (numSize === 30 ? '30ML' : (numSize === 60 ? '60ML' : '130GM'))),
          whiteCapNo: numSize <= 20 ? '22 no' : '25 no',
          whiteCapQty: 1,
          puriaQty: 0
        };
      }
    }
  } else if (activeTabState === 'SAC_LAC_DOSE') {
    const fallbackList = PURIA_RATES[selectedPuriaDoctor] || PURIA_RATES.STANDARD;
    const fallbackItem = fallbackList.find(item => item.doseCount === selectedPuriaDose) || fallbackList[0];
    const dbRule = tabRules.find(r => r.doseCount === selectedPuriaDose);

    const unitPrice = dbRule && parseFloat(dbRule.sellingPrice) > 0 ? parseFloat(dbRule.sellingPrice) : (fallbackItem?.price || 9);
    const medType = dbRule?.medicineType || (selectedPuriaDoctor === 'KKG' ? 'KKG Puria' : selectedPuriaDoctor === 'SKM' ? 'SKM / SKD Puria' : selectedPuriaDoctor === 'LM' ? 'Millesimal Puria' : 'Dilution Puria');

    activeRule = {
      category: 'SAC_LAC_DOSE',
      dispensingForm: 'PURIA',
      medicineType: medType,
      salesSize: safePuriaCount,
      salesUnit: 'PURIA',
      puriaCount: safePuriaCount,
      puriaQty: safePuriaCount,
      unitSellingPrice: unitPrice,
      sellingPrice: unitPrice * safePuriaCount,
      rawMaterialConsumed: +(0.1 * safePuriaCount).toFixed(2),
      rawMaterialUnit: 'ML',
      globulesWeight: +(0.769 * safePuriaCount).toFixed(3),
      globulesSize: 'powder',
      drops: `${2 * safePuriaCount} drops`,
      volume: `${(0.1 * safePuriaCount).toFixed(1)}ml`,
      doseCount: selectedPuriaDose,
      description: `${selectedPuriaDoctor === 'KKG' ? 'Dr. KKG ' : selectedPuriaDoctor === 'SKM' ? 'Dr. SKM/SKD ' : selectedPuriaDoctor === 'LM' ? 'LM ' : ''}${selectedPuriaDose} (${safePuriaCount} Puria${safePuriaCount > 1 ? 's' : ''})`
    };
  } else if (activeTabState === 'MOTHER_TINCTURE') {
    const numSize = parseFloat(selectedSize) || 30;
    activeRule = tabRules.find(r => r.medicineType === selectedMTGroup && parseFloat(r.salesSize) === numSize);
  } else if (activeTabState === 'DILUTION_LIQUID' || activeTabState === 'MEDICATED_GLOBULES') {
    const numSize = parseFloat(selectedSize);
    activeRule = tabRules.find(r => r.medicineType === selectedPotencyGroup && parseFloat(r.salesSize) === numSize);
    if (!activeRule) {
      activeRule = tabRules.find(r => parseFloat(r.salesSize) === numSize);
    }
  } else if (activeTabState === 'BIOCHEMIC') {
    const numSize = parseFloat(selectedSize);
    activeRule = tabRules.find(r => parseFloat(r.salesSize) === numSize);
  } else {
    activeRule = tabRules.find(r => r.doseCount === selectedDoseCount);
  }

  const resolvedMaterials = activeRule ? resolveRuleMaterials(activeRule, dispenseMaterials) : [];
  const materialsCost = activeRule ? getDispenseMaterialsCost(activeRule, dispenseMaterials) : 0;
  const calculatedPrice = activeRule && parseFloat(activeRule.sellingPrice) > 0 ? parseFloat(activeRule.sellingPrice) : materialsCost;

  // Available options
  const sizes = activeTabState === 'TRITURATION'
    ? TRIT_SIZES
    : (activeTabState === 'MOTHER_TINCTURE'
      ? MT_SIZES
      : (activeTabState === 'DILUTION_LIQUID' || activeTabState === 'MEDICATED_GLOBULES'
        ? [...new Set(tabRules.filter(r => r.medicineType === selectedPotencyGroup).map(r => r.salesSize))].sort((a, b) => parseFloat(a) - parseFloat(b))
        : [...new Set(tabRules.map(r => r.salesSize))].sort((a, b) => parseFloat(a) - parseFloat(b))));

  const dosesList = [...tabRules].sort((a, b) => {
    const numA = parseInt(a.doseCount?.replace(/\D/g, '')) || 0;
    const numB = parseInt(b.doseCount?.replace(/\D/g, '')) || 0;
    return numA - numB;
  });

  const getGlobuleRefBottle = (weight) => {
    const w = parseFloat(weight);
    if (w === 5) return "10 ML";
    if (w === 10) return "15 ML / 20 ML";
    if (w === 15) return "30 ML";
    if (w === 20) return "60 ML";
    if (w === 30) return "100 ML";
    return "N/A";
  };

  const getGlobuleRefAlt = (weight) => {
    const w = parseFloat(weight);
    if (w === 5) return "4gm Glo";
    if (w === 10) return "8gm glo";
    if (w === 15) return "12gm Glo";
    if (w === 20) return "16gm Glo";
    if (w === 30) return "25gm Glo";
    if (w === 60) return "50gm Glo";
    if (w === 100) return "84gm glo";
    return "";
  };

  const handleConfirm = () => {
    if (activeRule) {
      onSelect(activeRule);
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)", zIndex: 1100 }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-primary shadow-lg">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title d-flex align-items-center gap-2">
              🧪 Homeopathic Dispensing & Loose Calculation
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body p-4">
            {/* Step 1: Form Tabs */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="fw-bold mb-0">1. Select Dispensing Form:</label>
              <div className="d-flex align-items-center gap-1">
                <span className="badge bg-primary-subtle text-primary border border-primary px-2 py-1" style={{ fontSize: '0.75rem' }}>
                  Product: {typeInfo.label}
                </span>
                {typeInfo.allowedTabs.length === 1 && (
                  <span className="badge bg-success-subtle text-success border border-success px-2 py-1" style={{ fontSize: '0.75rem' }}>
                    ✓ Auto-Selected
                  </span>
                )}
              </div>
            </div>

            <div className="row g-2 mb-3">
              {categories.map(cat => {
                const isAllowed = typeInfo.allowedTabs.includes(cat.key);
                const isActive = activeTabState === cat.key;

                return (
                  <div className="col-6 col-md-3" key={cat.key}>
                    <button
                      type="button"
                      disabled={!isAllowed}
                      className={`btn w-100 py-2 h-100 d-flex flex-column align-items-center justify-content-center border-2 ${!isAllowed
                        ? 'btn-light border-secondary-subtle text-muted'
                        : isActive
                          ? 'btn-primary border-primary shadow-sm'
                          : 'btn-outline-secondary border-2'
                        }`}
                      style={!isAllowed ? { opacity: 0.35, cursor: 'not-allowed', filter: 'grayscale(0.8)' } : {}}
                      onClick={() => isAllowed && setActiveTabState(cat.key)}
                      title={!isAllowed ? 'Disabled: Not applicable for this product category' : cat.label}
                    >
                      <span className="fs-4 mb-1">{cat.label.split(" ")[0]}</span>
                      <span className="fw-bold" style={{ fontSize: '0.8rem' }}>
                        {cat.label.split(" ").slice(1).join(" ")}
                      </span>
                      <small className="text-muted mt-1 text-center" style={{ fontSize: '0.65rem' }}>
                        {!isAllowed ? 'Disabled for product' : cat.desc}
                      </small>
                    </button>
                  </div>
                );
              })}
            </div>

            {/* TRITURATION CATEGORY SELECTOR */}
            {activeTabState === 'TRITURATION' && (
              <div className="mb-3 p-3 bg-light border rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <label className="fw-bold mb-0 text-primary">
                      2. Select Trituration Category (Apr. 24):
                    </label>
                    {typeInfo.isTritCatLocked && (
                      <span className="badge bg-success" style={{ fontSize: '0.7rem' }}>
                        🔒 Locked ({typeInfo.detectedTritCat})
                      </span>
                    )}
                  </div>
                  {pendingData?.product?.variant_name && (
                    <span className="badge bg-dark">
                      Potency: {pendingData.product.variant_name}
                    </span>
                  )}
                </div>
                <div className="d-flex flex-wrap gap-2">
                  {TRITURATION_CATS.map(cat => {
                    const isSelected = selectedTritCategory === cat;
                    const isOtherDisabled = typeInfo.isTritCatLocked && cat !== typeInfo.detectedTritCat;

                    return (
                      <button
                        key={cat}
                        type="button"
                        disabled={isOtherDisabled}
                        className={`btn px-3 py-1 ${isSelected ? 'btn-primary fw-bold shadow-sm' : isOtherDisabled ? 'btn-outline-secondary opacity-50' : 'btn-outline-primary'}`}
                        style={isOtherDisabled ? { cursor: 'not-allowed' } : {}}
                        onClick={() => !isOtherDisabled && setSelectedTritCategory(cat)}
                      >
                        {cat}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* MOTHER TINCTURE GROUP SELECTOR */}
            {activeTabState === 'MOTHER_TINCTURE' && (
              <div className="mb-3 p-3 bg-light border rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="fw-bold mb-0 text-primary">
                    2. Select JNM Mother Tincture Group:
                  </label>
                  {typeInfo.isMTGroupLocked && (
                    <span className="badge bg-success" style={{ fontSize: '0.7rem' }}>
                      🔒 Locked ({typeInfo.detectedMTGroup})
                    </span>
                  )}
                </div>
                <div className="d-flex flex-wrap gap-1">
                  {MT_GROUPS.map(grp => {
                    const isSelected = selectedMTGroup === grp;
                    const isOtherDisabled = typeInfo.isMTGroupLocked && grp !== typeInfo.detectedMTGroup;

                    return (
                      <button
                        key={grp}
                        type="button"
                        disabled={isOtherDisabled}
                        className={`btn btn-sm ${isSelected ? 'btn-primary fw-bold shadow-sm' : isOtherDisabled ? 'btn-outline-secondary opacity-50' : 'btn-outline-primary'}`}
                        style={isOtherDisabled ? { cursor: 'not-allowed' } : {}}
                        onClick={() => !isOtherDisabled && setSelectedMTGroup(grp)}
                      >
                        {grp}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* LIQUID DILUTION POTENCY SELECTOR */}
            {activeTabState === 'DILUTION_LIQUID' && (
              <div className="mb-3 p-3 bg-light border rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <label className="fw-bold mb-0 text-primary">
                      2. Select Liquid Potency Rate Group:
                    </label>
                    {typeInfo.isPotencyLocked && (
                      <span className="badge bg-success" style={{ fontSize: '0.7rem' }}>
                        🔒 Locked ({typeInfo.detectedPotency})
                      </span>
                    )}
                  </div>
                  {pendingData?.product?.variant_name && (
                    <span className="badge bg-dark">
                      Potency: {pendingData.product.variant_name}
                    </span>
                  )}
                </div>
                <div className="d-flex flex-wrap gap-2">
                  {LIQUID_POTENCY_GROUPS.map(pot => {
                    const isSelected = selectedPotencyGroup === pot;
                    const isOtherDisabled = typeInfo.isPotencyLocked && pot !== typeInfo.detectedPotency;

                    return (
                      <button
                        key={pot}
                        type="button"
                        disabled={isOtherDisabled}
                        className={`btn px-3 py-1 ${isSelected ? 'btn-primary fw-bold shadow-sm' : isOtherDisabled ? 'btn-outline-secondary opacity-50' : 'btn-outline-primary'}`}
                        style={isOtherDisabled ? { cursor: 'not-allowed' } : { fontSize: '0.85rem' }}
                        onClick={() => !isOtherDisabled && setSelectedPotencyGroup(pot)}
                      >
                        {pot}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* MEDICATED GLOBULES POTENCY SELECTOR */}
            {activeTabState === 'MEDICATED_GLOBULES' && (
              <div className="mb-3 p-3 bg-light border rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <label className="fw-bold mb-0 text-primary">
                      2. Select Globules Potency Rate Group:
                    </label>
                    {typeInfo.isPotencyLocked && (
                      <span className="badge bg-success" style={{ fontSize: '0.7rem' }}>
                        🔒 Locked ({typeInfo.detectedPotency})
                      </span>
                    )}
                  </div>
                  {pendingData?.product?.variant_name && (
                    <span className="badge bg-dark">
                      Potency: {pendingData.product.variant_name}
                    </span>
                  )}
                </div>
                <div className="d-flex flex-wrap gap-2">
                  {GLOBULE_POTENCY_GROUPS.map(pot => {
                    const isSelected = selectedPotencyGroup === pot;
                    const isOtherDisabled = typeInfo.isPotencyLocked && pot !== typeInfo.detectedPotency;

                    return (
                      <button
                        key={pot}
                        type="button"
                        disabled={isOtherDisabled}
                        className={`btn px-3 py-1 ${isSelected ? 'btn-primary fw-bold shadow-sm' : isOtherDisabled ? 'btn-outline-secondary opacity-50' : 'btn-outline-primary'}`}
                        style={isOtherDisabled ? { cursor: 'not-allowed' } : { fontSize: '0.85rem' }}
                        onClick={() => !isOtherDisabled && setSelectedPotencyGroup(pot)}
                      >
                        {pot}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* SAC LAC / PURIA DOCTOR & POTENCY SELECTOR */}
            {activeTabState === 'SAC_LAC_DOSE' && (
              <div className="mb-3 p-3 bg-light border rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="fw-bold mb-0 text-primary">
                    2. Select Doctor / Pricing Category (wef 01.04.26):
                  </label>
                  {pendingData?.product?.variant_name && (
                    <span className="badge bg-dark">
                      Potency: {pendingData.product.variant_name}
                    </span>
                  )}
                </div>
                <div className="row g-2 mb-3">
                  {PURIA_DOCTORS.map(doc => {
                    const isSelected = selectedPuriaDoctor === doc.id;
                    return (
                      <div className="col-6 col-md-3" key={doc.id}>
                        <button
                          type="button"
                          className={`btn w-100 py-2 h-100 text-start border-2 ${isSelected ? 'btn-primary shadow-sm fw-bold' : 'btn-outline-primary'}`}
                          onClick={() => setSelectedPuriaDoctor(doc.id)}
                        >
                          <div className="fw-bold" style={{ fontSize: '0.82rem' }}>{doc.label}</div>
                          <small className={isSelected ? 'text-white-50' : 'text-muted'} style={{ fontSize: '0.67rem' }}>
                            {doc.desc}
                          </small>
                        </button>
                      </div>
                    );
                  })}
                </div>

                <label className="fw-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>
                  3. Select Potency Tier / Dose Rate:
                </label>
                <div className="d-flex flex-wrap gap-2">
                  {(PURIA_RATES[selectedPuriaDoctor] || []).map(opt => {
                    const isSelected = selectedPuriaDose === opt.doseCount;
                    return (
                      <button
                        key={opt.doseCount}
                        type="button"
                        className={`btn px-3 py-2 ${isSelected ? 'btn-dark shadow-sm' : 'btn-outline-dark'}`}
                        onClick={() => setSelectedPuriaDose(opt.doseCount)}
                      >
                        <span className="fw-bold">{opt.label}</span>
                        <small className={`d-block fw-bold ${isSelected ? 'text-warning' : 'text-success'}`} style={{ fontSize: '0.85rem' }}>
                          ₹{opt.price} / puria
                        </small>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Step 2/3: Doses / Sizes Selection */}
            {["TRITURATION", "MOTHER_TINCTURE", "DILUTION_LIQUID", "MEDICATED_GLOBULES", "BIOCHEMIC"].includes(activeTabState) && (
              <div className="mb-3">
                <label className="fw-bold mb-2">
                  {['TRITURATION', 'MOTHER_TINCTURE', 'DILUTION_LIQUID', 'MEDICATED_GLOBULES'].includes(activeTabState) ? '3.' : '2.'} Select {
                    activeTabState === "TRITURATION" ? "Trituration Package Size" :
                      activeTabState === "MOTHER_TINCTURE" ? "Bottle Volume" :
                        activeTabState === "DILUTION_LIQUID" ? "Liquid Bottle Volume" :
                          activeTabState === "BIOCHEMIC" ? "Biochemic Weight" : "Globules Weight"
                  }:
                </label>
                <div className="d-flex flex-wrap gap-2">
                  {sizes.map(size => {
                    const isSelected = activeTabState === 'TRITURATION' || activeTabState === 'MOTHER_TINCTURE'
                      ? selectedSize === size
                      : parseFloat(selectedSize) === parseFloat(size);

                    let pricePreview = '';
                    if (activeTabState === 'TRITURATION') {
                      const p = TRITURATION_FALLBACK_RATES[selectedTritCategory]?.[size];
                      if (p) pricePreview = size === 'Puria' ? `₹${p}/puria` : `₹${p}`;
                    } else if (activeTabState === 'MOTHER_TINCTURE') {
                      const numSize = parseFloat(size);
                      const r = tabRules.find(rule => rule.medicineType === selectedMTGroup && parseFloat(rule.salesSize) === numSize);
                      if (r && r.sellingPrice) pricePreview = `₹${parseFloat(r.sellingPrice).toFixed(0)}`;
                    } else if (activeTabState === 'DILUTION_LIQUID' || activeTabState === 'MEDICATED_GLOBULES') {
                      const numSize = parseFloat(size);
                      const r = tabRules.find(rule => rule.medicineType === selectedPotencyGroup && parseFloat(rule.salesSize) === numSize);
                      if (r && r.sellingPrice) pricePreview = `₹${parseFloat(r.sellingPrice).toFixed(0)}`;
                    } else if (activeTabState === 'BIOCHEMIC') {
                      const numSize = parseFloat(size);
                      const r = tabRules.find(rule => parseFloat(rule.salesSize) === numSize);
                      if (r && r.sellingPrice) pricePreview = `₹${parseFloat(r.sellingPrice).toFixed(0)}`;
                    }

                    return (
                      <button
                        key={size}
                        type="button"
                        className={`btn px-3 py-2 ${isSelected ? 'btn-dark shadow-sm' : 'btn-outline-dark'}`}
                        onClick={() => setSelectedSize(size)}
                      >
                        <span className="fw-bold">{size} {(!size.endsWith('gm') && !size.endsWith('ml') && size !== 'Puria' && activeTabState !== 'TRITURATION' && activeTabState !== 'MOTHER_TINCTURE') ? (activeTabState === "DILUTION_LIQUID" ? "ml" : "gm") : ''}</span>
                        {pricePreview && (
                          <small className={`d-block fw-bold ${isSelected ? 'text-warning' : 'text-success'}`} style={{ fontSize: '0.8rem' }}>
                            {pricePreview}
                          </small>
                        )}
                        {activeTabState === "MEDICATED_GLOBULES" && getGlobuleRefAlt(size) && (
                          <small className={`d-block ${isSelected ? 'text-white-50' : 'text-muted'}`} style={{ fontSize: '0.7rem' }}>
                            ({getGlobuleRefAlt(size)})
                          </small>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* DW DOSE FORMULATION SELECTION */}
            {activeTabState === 'DW_DOSE' && (
              <div className="mb-4">
                <label className="fw-bold mb-2">2. Select Distilled Water Formulation:</label>
                <div className="row g-2" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                  {dosesList.map(doseRule => {
                    const isSelected = selectedDoseCount === doseRule.doseCount;
                    return (
                      <div className="col-12 col-sm-6" key={doseRule.id}>
                        <button
                          type="button"
                          className={`btn w-100 py-2 px-3 d-flex justify-content-between align-items-center text-start border-2 ${isSelected ? 'btn-dark border-dark shadow-sm' : 'btn-outline-dark'}`}
                          onClick={() => setSelectedDoseCount(doseRule.doseCount)}
                        >
                          <div className="text-truncate me-2">
                            <span className="fw-bold d-block text-truncate" style={{ fontSize: '0.85rem' }}>
                              {doseRule.doseCount}
                            </span>
                            {doseRule.medicineType && (
                              <small className={isSelected ? 'text-white-50' : 'text-muted'} style={{ fontSize: '0.7rem' }}>
                                {doseRule.medicineType}
                              </small>
                            )}
                          </div>
                          {parseFloat(doseRule.sellingPrice) > 0 && (
                            <span className={`badge ${isSelected ? 'bg-warning text-dark' : 'bg-success text-white'} fs-12 px-2 py-1`}>
                              ₹{parseFloat(doseRule.sellingPrice).toFixed(0)}
                            </span>
                          )}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* PURIA QUANTITY SELECTOR (For SAC_LAC_DOSE or TRITURATION Puria) */}
            {(activeTabState === 'SAC_LAC_DOSE' || (activeTabState === 'TRITURATION' && selectedSize === 'Puria')) && (
              <div className="mb-4 p-3 bg-white border border-primary-subtle rounded-3 shadow-sm">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="fw-bold text-primary mb-0 d-flex align-items-center gap-1">
                    <span>✉️ Number of Puria Packets (Qty):</span>
                  </label>
                  <span className="badge bg-primary fs-13 px-2 py-1">
                    {safePuriaCount} {safePuriaCount === 1 ? 'Puria' : 'Purias'}
                  </span>
                </div>

                <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                  <div className="input-group" style={{ width: '140px' }}>
                    <button
                      type="button"
                      className="btn btn-outline-secondary fw-bold"
                      onClick={() => setPuriaCount(Math.max(1, safePuriaCount - 1))}
                    >
                      -
                    </button>
                    <input
                      type="number"
                      min="1"
                      max="500"
                      className="form-control text-center fw-bold"
                      value={puriaCount}
                      onChange={(e) => setPuriaCount(Math.max(1, parseInt(e.target.value) || 1))}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary fw-bold"
                      onClick={() => setPuriaCount(safePuriaCount + 1)}
                    >
                      +
                    </button>
                  </div>

                  <div className="d-flex flex-wrap gap-1">
                    {[1, 2, 3, 4, 5, 6, 10, 15, 20, 30].map(qty => (
                      <button
                        key={qty}
                        type="button"
                        className={`btn btn-sm ${safePuriaCount === qty ? 'btn-primary fw-bold' : 'btn-outline-secondary'}`}
                        onClick={() => setPuriaCount(qty)}
                      >
                        {qty} {qty === 1 ? 'Puria' : 'Purias'}
                      </button>
                    ))}
                  </div>
                </div>

                {activeRule && (
                  <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded">
                    <small className="text-muted">
                      Unit Cost: <strong>₹{activeRule.unitSellingPrice || (activeRule.sellingPrice / safePuriaCount)} / puria</strong> × <strong>{safePuriaCount} Purias</strong>
                    </small>
                    <span className="badge bg-success fs-13">
                      Total: ₹{calculatedPrice.toFixed(2)}
                    </span>
                  </div>
                )}
              </div>
            )}

            {/* Step 3/4: Dispensing & Formulation Summary Card */}
            {activeRule && (
              <div className="card bg-light border-0 shadow-sm rounded-3">
                <div className="card-header bg-dark text-white fw-bold py-2 d-flex justify-content-between align-items-center">
                  <span>📋 Formulation & Price Summary</span>
                  <span className="badge bg-success fs-14">
                    ₹{calculatedPrice.toFixed(2)}
                  </span>
                </div>
                <div className="card-body p-3">
                  <div className="row g-3">
                    <div className="col-md-6 border-end">
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Dispensing Form:</span>
                        <strong className="text-primary">{activeRule.dispensingForm || activeRule.category}</strong>
                      </div>

                      {activeTabState === "TRITURATION" && (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Category:</span>
                            <strong className="text-primary">{activeRule.medicineType}</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Dispense Size:</span>
                            <strong className="text-dark">
                              {activeRule.dispensingForm === 'PURIA'
                                ? `${activeRule.puriaCount || 1} Puria${(activeRule.puriaCount || 1) > 1 ? 's' : ''} (₹${activeRule.unitSellingPrice || (activeRule.sellingPrice / (activeRule.puriaCount || 1))}/ea)`
                                : `${activeRule.salesSize} ${activeRule.salesUnit}`}
                            </strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Trituration Consumed:</span>
                            <strong className="text-success">{activeRule.rawMaterialConsumed} {activeRule.rawMaterialUnit || 'GM'}</strong>
                          </div>
                          {activeRule.bottleSize && (
                            <div className="d-flex justify-content-between">
                              <span className="text-muted">Bottle Required:</span>
                              <strong className="text-info">{activeRule.bottleSize}</strong>
                            </div>
                          )}
                        </>
                      )}

                      {activeTabState === "MOTHER_TINCTURE" && (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Group:</span>
                            <strong className="text-primary">{activeRule.medicineType}</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Bottle Size:</span>
                            <strong className="text-dark">{activeRule.salesSize} ml</strong>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span className="text-muted">Medicine Consumed:</span>
                            <strong className="text-success">{activeRule.rawMaterialConsumed || activeRule.salesSize} ml</strong>
                          </div>
                        </>
                      )}

                      {activeTabState === "DILUTION_LIQUID" && (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Potency Group:</span>
                            <strong className="text-primary">{activeRule.medicineType}</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Bottle Volume:</span>
                            <strong>{activeRule.salesSize} ml</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Medicine Dilution:</span>
                            <strong className="text-success">{activeRule.rawMaterialConsumed} ml</strong>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span className="text-muted">Spirit/Alcohol base:</span>
                            <strong className="text-secondary">{(parseFloat(activeRule.salesSize) - parseFloat(activeRule.rawMaterialConsumed)).toFixed(1)} ml</strong>
                          </div>
                        </>
                      )}

                      {activeTabState === "MEDICATED_GLOBULES" && (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Potency Group:</span>
                            <strong className="text-primary">{activeRule.medicineType}</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Globules Weight:</span>
                            <strong>{activeRule.salesSize} gm</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Active Dilution:</span>
                            <strong className="text-success">{activeRule.drops} ({activeRule.volume})</strong>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span className="text-muted">Required Bottle Size:</span>
                            <strong className="text-info">{getGlobuleRefBottle(activeRule.salesSize)}</strong>
                          </div>
                        </>
                      )}

                      {activeTabState === "SAC_LAC_DOSE" && (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Doctor / Category:</span>
                            <strong className="text-primary">{activeRule.medicineType}</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Potency / Dose:</span>
                            <strong>{activeRule.doseCount}</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Puria Quantity:</span>
                            <strong className="text-dark">{activeRule.puriaCount || 1} Puria{(activeRule.puriaCount || 1) > 1 ? 's' : ''} (₹{activeRule.unitSellingPrice || (activeRule.sellingPrice / (activeRule.puriaCount || 1))}/ea)</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Medicine Dilution:</span>
                            <strong className="text-success">{activeRule.drops} ({activeRule.volume})</strong>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span className="text-muted">Sugar Base (Sac Lac):</span>
                            <strong className="text-secondary">{activeRule.globulesWeight} gm</strong>
                          </div>
                        </>
                      )}

                      {activeTabState === "DW_DOSE" && (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Dose Limit / Volume:</span>
                            <strong>{activeRule.doseCount}</strong>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Distilled Water base:</span>
                            <strong>{activeRule.doseCount?.match(/\d+ml/i)?.[0] || "30ml"}</strong>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span className="text-muted">Active Dilution:</span>
                            <strong className="text-success">{activeRule.drops} ({activeRule.volume})</strong>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="col-md-6 d-flex flex-column justify-content-between pl-3">
                      <div>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Amount Calculated:</span>
                          <strong className="text-success fs-16">₹{calculatedPrice.toFixed(2)}</strong>
                        </div>
                        {activeRule.description && (
                          <div className="alert alert-warning py-1 px-2 mb-0" style={{ fontSize: '0.75rem' }}>
                            💡 {activeRule.description}
                          </div>
                        )}
                        {activeTabState === "DILUTION_LIQUID" && (
                          <div className="alert alert-info py-1 px-2 mt-2 mb-0" style={{ fontSize: '0.75rem' }}>
                            Spirit formulation: Remaining bottle volume is automatically filled by Alcohol.
                          </div>
                        )}
                        {activeTabState === "TRITURATION" && (
                          <div className="alert alert-info py-1 px-2 mt-2 mb-0" style={{ fontSize: '0.75rem' }}>
                            Trituration (Apr. 24): Amount set from Category rate table.
                          </div>
                        )}
                        {activeTabState === "SAC_LAC_DOSE" && (
                          <div className="alert alert-info py-1 px-2 mt-2 mb-0" style={{ fontSize: '0.75rem' }}>
                            Puriya Price Revision (wef 01.04.26): Rate per puriya × quantity.
                          </div>
                        )}

                        <div className="mt-3">
                          <span className="text-muted d-block mb-1 fw-bold" style={{ fontSize: '0.8rem' }}>Deducted Materials:</span>
                          <div className="d-flex flex-column gap-1 bg-white p-2 rounded border" style={{ maxHeight: '110px', overflowY: 'auto' }}>
                            {resolvedMaterials.length > 0 ? (
                              resolvedMaterials.map((item, idx) => (
                                <div key={idx} className="d-flex justify-content-between align-items-center py-1 border-bottom border-secondary-subtle border-opacity-10" style={{ fontSize: '0.8rem' }}>
                                  <span className="text-dark">📦 {item.material?.name || 'Material'}</span>
                                  <span className="badge bg-secondary">{item.qty} {item.material?.unit || ''}</span>
                                </div>
                              ))
                            ) : (
                              <span className="text-muted small">Standard Packaging Applied.</span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="text-end pt-3 border-top mt-2">
                        <small className="text-muted d-block">Price to be charged in cart:</small>
                        <span className="fs-3 fw-bold text-success">₹{calculatedPrice.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success px-4"
              onClick={handleConfirm}
              disabled={!activeRule}
            >
              Confirm & Dispense
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PosModel;